/**
 * Program Inclusion Reducers
 */
import {
    PROGRAM_INCLUSION_ACTION1,
    GET_PROGRAM_INCLUSION,
    ADD_PROGRAM_INCLUSION1,
    DELETE_PROGRAM_INCLUSIONS,
    EDIT_PROGRAM_INCLUSIONS
} from 'Actions/types';


const INIT_STATE = {
    programinclusionlist1: [],
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case PROGRAM_INCLUSION_ACTION1:
            return { ...state, loading: true };

        case GET_PROGRAM_INCLUSION:
            return { ...state, loading: false, programinclusionlist1: action.payload };

        case ADD_PROGRAM_INCLUSION1:
            return { ...state, loading: true };

        case DELETE_PROGRAM_INCLUSIONS:
            return { ...state, loading: true };

        case EDIT_PROGRAM_INCLUSIONS:
            return { ...state, loading: true };

        default: return { ...state };

    }
}